import { createRoute } from "@tanstack/react-router";

import { requirePermission } from "@platform/auth/guards";
import { shellRoute } from "@platform/shell.route";
import { WebhookEndpointPage } from "./webhook-endpoint.page";
import { WebhooksPage } from "./webhooks.page";

// Members hold no webhook permission: an endpoint URL often carries a token, and a delivery's
// excerpt is the customer's own server answering.
export const webhooksRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/webhooks",
	beforeLoad: ({ context }) => requirePermission(context.queryClient, { webhook: ["read"] }),
	component: WebhooksPage,
});

export const webhookEndpointRoute = createRoute({
	getParentRoute: () => shellRoute,
	path: "/webhooks/$endpointId",
	beforeLoad: ({ context }) => requirePermission(context.queryClient, { webhook: ["read"] }),
	component: WebhookEndpointPage,
});
